import { ChangeDetectorRef, Component, ElementRef, Inject, PLATFORM_ID, HostListener, ViewChild } from '@angular/core';
import { RedirectRouterService } from '@shared/services/web/redirect-router.service';
import { IMeta, MetaService } from '@shared/services/web/meta.service';
import { MatDialog } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ASSETS_API_URL } from '@app/app.constants';
import { Subscription } from 'rxjs';
// declare const hbspt: any; // Declaración del componente HS para el formulario de Newsletter
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { WeCallYouComponent } from '@app/@shared/components/we-call-you/we-call-you.component';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  isLoading = false;
  language = 'es';
  isMobile = false;
  allProvinces: Array<any> = [];
  public picturesServer = ASSETS_API_URL;
  private changeLangSubscription: Subscription;
  private static readonly HOME_VIDEO_BASE_URL = 'https://d1w3nj0fsqjjqy.cloudfront.net/assets/video/Home_CEO_';

  @ViewChild('homeVideo') homeVideoRef: ElementRef<HTMLVideoElement>;

  get videoSrc(): string {
    return `${HomeComponent.HOME_VIDEO_BASE_URL}${this.language === 'en' ? 'en' : 'es'}.mp4`;
  }

  constructor(
    public router: Router,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private metaService: MetaService,
    private redirectService: RedirectRouterService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platform: any,
  ) {}
  ngOnInit() {
    this.language = this.translateService.currentLang;

    // set initial mobile flag
    this.updateIsMobile();

    this.changeLangSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.language = event.lang;
        this.changeMeta();
        // El <source [src]> por si solo no recarga un <video> ya cargado (spec HTML):
        // forzamos la actualizacion del binding y luego .load() para que tome el video del nuevo idioma.
        this.cdr.detectChanges();
        this.homeVideoRef?.nativeElement.load();
      }
    );
    if (window.location.pathname == '/') {
      this.redirectService.goToPage('/');
    }
    if (isPlatformBrowser(this.platform)) {
      // here you can run any browser specific code, like:
      window.scroll(0, 0);

      // hbspt.forms.create({
      //   region: 'na1',
      //   portalId: '7733651',
      //   formId: 'a70dd97e-4c18-4de9-9405-4d93a33fefb8',
      //   target: '#hubspotForm',
      // });
    }
    this.isLoading = false;
  }

  @HostListener('window:resize')
  onResize() {
    this.updateIsMobile();
  }

  private updateIsMobile() {
    if (isPlatformBrowser(this.platform)) {
      this.isMobile = window.innerWidth <= 600;
    } else {
      this.isMobile = false;
    }
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'home',
      description: 'home_desc',
    };
    this.metaService.changeMeta(meta);
  }

  public navigateInvertir() {
    this.redirectService.goToPage('/invertir');
  }

  public navigatePropietario() {
    this.redirectService.goToPage(`/vende`);
  }
  navigateInquilino() {
    this.redirectService.goToPage(`/sobre-nosotros/inquilino`);
  }

  navigateComoTrabajamos() {
    this.redirectService.goToPage(`/sobre-nosotros/como-trabajamos`);
  }

  setBreadcrumb() {
    // this.breadcrumbsService.setBreadcrumb([]);
  }

  closeModalPopUp() {
    // this.modalService.dismissAll();
  }
  ngOnDestroy(): void {
    if (this.changeLangSubscription) {
      this.changeLangSubscription.unsubscribe();
    }
  }

  playVideo(event: Event): void {
    if (isPlatformBrowser(this.platform)) {
      (event.target as HTMLVideoElement).play();
    }
  }

  openCallModal() {
    this.dialog.open(WeCallYouComponent, {
      maxWidth: '95vw',
      panelClass: 'noPadding',
    });
  }
  getBackgroundImage(type: string) {
    let imageUrl = '';
    switch (type) {
      case 'object':
        imageUrl = 'url(' + this.picturesServer + 'img/home/object-e.svg)';
        break;
      case 'underline':
        imageUrl =
          'url(' + this.picturesServer + 'img/home/illu-underline.svg)';
        break;
      default:
        imageUrl = '';
        break;
    }
    return imageUrl;
  }
}
